// // src/pages/IoTServices.jsx
// import React from "react";
// import "./ServicePage.css";
// import {
//   FaMicrochip,
//   FaWifi,
//   FaIndustry,
//   FaChartLine,
//   FaCogs,
//   FaShieldAlt,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";

// export default function IoTServices() {
//   return (
//     <div className="svc-page">
//       {/* HERO */}
//       <section className="svc-hero">
//         <div className="svc-hero-inner">
//           <div className="svc-hero-left">
//             <span className="svc-hero-tag">IoT Services</span>
//             <h1 className="svc-hero-title">
//               Connect your{" "}
//               <span className="svc-hero-highlight">devices, data,</span> and
//               decisions.
//             </h1>
//             <p className="svc-hero-subtitle">
//               We design and build end-to-end IoT solutions — from edge devices
//               to cloud dashboards — so your teams can monitor, automate, and act
//               in real time.
//             </p>

//             <ul className="svc-hero-points">
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Device connectivity, data pipelines, and control panels.
//                 </span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Custom dashboards for operations, maintenance, and alerts.
//                 </span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Secure, scalable architecture for industrial-grade IoT.
//                 </span>
//               </li>
//             </ul>

//             {/* <div className="svc-hero-cta-row">
//               <button className="svc-cta-primary">Discuss an IoT Project</button>
//               <button className="svc-cta-secondary">
//                 View Sample Dashboards
//               </button>
//             </div> */}
//           </div>

//           {/* RIGHT SIDE VISUAL */}
//           <div className="svc-hero-right">
//             <div className="svc-hero-orbit">
//               <div className="svc-hero-orbit-ring" />
//               <div className="svc-hero-orbit-center">
//                 <FaMicrochip />
//               </div>

//               <div className="svc-hero-pill-icon svc-hero-pill-top">
//                 <span className="svc-pill-dot" />
//                 <span>Sensor Data</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-right">
//                 <span className="svc-pill-dot" />
//                 <span>Device Control</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-bottom">
//                 <span className="svc-pill-dot" />
//                 <span>Live Alerts</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* METRICS */}
//         <div className="svc-hero-metrics">
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">1000+ devices</div>
//             <div className="svc-metric-label">Managed across deployments</div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">40% ↓</div>
//             <div className="svc-metric-label">
//               Downtime with predictive alerts
//             </div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">24×7</div>
//             <div className="svc-metric-label">Monitoring & dashboards</div>
//           </div>
//         </div>
//       </section>

//       {/* MAIN CONTENT */}
//       <main className="svc-inner">
//         {/* WHAT WE BUILD */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>What we build in IoT</h2>
//             <p>
//               End-to-end IoT solutions tailored to your industry, from connected
//               devices to cloud-based control centers.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaWifi />
//               </div>
//               <h3>Device Connectivity</h3>
//               <p>
//                 Connect sensors, gateways, and edge devices over Wi-Fi, 4G/5G,
//                 or LPWAN, with secure protocols and identity management.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaIndustry />
//               </div>
//               <h3>Industrial IoT Platforms</h3>
//               <p>
//                 Real-time dashboards for factories, logistics, and utilities —
//                 track assets, energy, production, and uptime in a single view.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaChartLine />
//               </div>
//               <h3>IoT Analytics & Insights</h3>
//               <p>
//                 Aggregate data into a central store, build visualizations, and
//                 add alerts so teams can act on trends, not just raw readings.
//               </p>
//             </div>
//           </div>
//         </section>

//         {/* USE CASES + BENEFITS */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>Where IoT fits in your business</h2>
//             <p>
//               Practical use cases that deliver measurable outcomes in
//               operations, maintenance, and customer experience.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <h3>Smart Operations</h3>
//               <ul className="svc-list">
//                 <li>Equipment health monitoring and threshold alerts.</li>
//                 <li>Remote control of devices from web or mobile apps.</li>
//                 <li>Real-time status for field teams and supervisors.</li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Predictive Maintenance</h3>
//               <ul className="svc-list">
//                 <li>Detect anomalies early with sensor patterns.</li>
//                 <li>
//                   Plan maintenance windows instead of reacting to failures.
//                 </li>
//                 <li>Extend asset life and reduce unexpected breakdowns.</li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Customer-Facing IoT</h3>
//               <ul className="svc-list">
//                 <li>Smart kiosks, connected devices, and mobile apps.</li>
//                 <li>Usage-based billing and subscription models.</li>
//                 <li>Telemetry-driven product improvements.</li>
//               </ul>
//             </div>
//           </div>
//         </section>

//         {/* PROCESS + STACK */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>How we deliver IoT projects</h2>
//             <p>
//               A structured approach that balances hardware constraints, cloud
//               scalability, and security.
//             </p>
//           </div>

//           <div className="svc-stats-row" style={{ marginBottom: "16px" }}>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">01 · Discover & Design</div>
//               <div className="svc-stat-value">
//                 Map devices, data points, user journeys, and integration
//                 touchpoints.
//               </div>
//             </div>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">02 · Build & Integrate</div>
//               <div className="svc-stat-value">
//                 Implement firmware, APIs, cloud services, and dashboards in
//                 small iterations.
//               </div>
//             </div>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">03 · Monitor & Scale</div>
//               <div className="svc-stat-value">
//                 Add alerts, analytics, and optimization as adoption grows.
//               </div>
//             </div>
//           </div>

//           <div className="svc-card">
//             <h3>Tech stack & platforms</h3>
//             <p className="svc-text-soft">
//               We work with cloud-native and open-source components that are easy
//               to maintain and extend.
//             </p>
//             <div className="svc-chip-row" style={{ marginTop: "10px" }}>
//               <span className="svc-chip">MQTT / WebSockets</span>
//               <span className="svc-chip">REST & GraphQL APIs</span>
//               <span className="svc-chip">AWS IoT / Azure IoT</span>
//               <span className="svc-chip">Time-series databases</span>
//               <span className="svc-chip">React / React Native</span>
//               <span className="svc-chip">Node.js / Python</span>
//             </div>
//           </div>

//           <div className="svc-cta-block">
//             <h3>Have an IoT idea or an existing device?</h3>
//             <p>
//               Share your current setup and what you want to measure or automate.
//               We’ll respond with a practical architecture and implementation
//               plan.
//             </p>
//             {/* <button className="svc-cta-primary">Schedule a 30-minute IoT consult</button> */}
//             <Link to="/contact">
//               <button className="svc-cta-primary">
//                 Schedule a 30-minute IoT consult{" "}
//               </button>
//             </Link>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }








// src/pages/IoTServices.jsx
import React from "react";
import "./ServicePage.css";
import {
  FaMicrochip,
  FaWifi,
  FaIndustry,
  FaChartLine,
  FaCogs,
  FaShieldAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function IoTServices() {
  return (
    <div className="svc-page">
      {/* HERO */}
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <div className="svc-hero-left">
            <span className="svc-hero-tag">IoT Services</span>
            <h1 className="svc-hero-title">
              Connect your{" "}
              <span className="svc-hero-highlight">devices, data,</span> and
              decisions.
            </h1>
            <p className="svc-hero-subtitle">
              We design and build end-to-end IoT solutions — from edge devices
              to cloud dashboards — so your teams can monitor, automate, and act
              in real time.
            </p>

            <ul className="svc-hero-points">
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Device connectivity, data pipelines, and control panels.
                </span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Custom dashboards for operations, maintenance, and alerts.
                </span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Secure, scalable architecture for industrial-grade IoT.
                </span>
              </li>
            </ul>

            {/* <div className="svc-hero-cta-row">
              <button className="svc-cta-primary">Discuss an IoT Project</button>
              <button className="svc-cta-secondary">
                View Sample Dashboards
              </button>
            </div> */}
          </div>

          {/* RIGHT SIDE VISUAL */}
          <div className="svc-hero-right">
            <div className="svc-hero-orbit">
              <div className="svc-hero-orbit-ring" />
              <div className="svc-hero-orbit-center">
                <FaMicrochip />
              </div>

              <div className="svc-hero-pill-icon svc-hero-pill-top">
                <span className="svc-pill-dot" />
                <span>Sensor Data</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-right">
                <span className="svc-pill-dot" />
                <span>Device Control</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-bottom">
                <span className="svc-pill-dot" />
                <span>Live Alerts</span>
              </div>
            </div>
          </div>
        </div>

        {/* METRICS */}
        <div className="svc-hero-metrics">
          <div className="svc-metric-card">
            <div className="svc-metric-number">1000+ devices</div>
            <div className="svc-metric-label">Managed across deployments</div>
          </div>
          <div className="svc-metric-card">
            <div className="svc-metric-number">40% ↓</div>
            <div className="svc-metric-label">
              Downtime with predictive alerts
            </div>
          </div>
          <div className="svc-metric-card">
            <div className="svc-metric-number">24×7</div>
            <div className="svc-metric-label">Monitoring & dashboards</div>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="svc-inner">
        {/* WHAT WE BUILD */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>What we build in IoT</h2>
            <p>
              End-to-end IoT solutions tailored to your industry, from connected
              devices to cloud-based control centers.
            </p>
          </div>

          <div className="svc-grid-3">
            <div className="svc-card">
              <div className="svc-card-icon">
                <FaWifi />
              </div>
              <h3>Device Connectivity</h3>
              <p>
                Connect sensors, gateways, and edge devices over Wi-Fi, 4G/5G,
                or LPWAN, with secure protocols and identity management.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaIndustry />
              </div>
              <h3>Industrial IoT Platforms</h3>
              <p>
                Real-time dashboards for factories, logistics, and utilities —
                track assets, energy, production, and uptime in a single view.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaChartLine />
              </div>
              <h3>IoT Analytics & Insights</h3>
              <p>
                Aggregate data into a central store, build visualizations, and
                add alerts so teams can act on trends, not just raw readings.
              </p>
            </div>
          </div>
        </section>

        {/* USE CASES + BENEFITS */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>Where IoT fits in your business</h2>
            <p>
              Practical use cases that deliver measurable outcomes in
              operations, maintenance, and customer experience.
            </p>
          </div>

          <div className="svc-grid-3">
            <div className="svc-card">
              <h3>Smart Operations</h3>
              <ul className="svc-list">
                <li>Equipment health monitoring and threshold alerts.</li>
                <li>Remote control of devices from web or mobile apps.</li>
                <li>Real-time status for field teams and supervisors.</li>
              </ul>
            </div>

            <div className="svc-card">
              <h3>Predictive Maintenance</h3>
              <ul className="svc-list">
                <li>Detect anomalies early with sensor patterns.</li>
                <li>
                  Plan maintenance windows instead of reacting to failures.
                </li>
                <li>Extend asset life and reduce unexpected breakdowns.</li>
              </ul>
            </div>

            <div className="svc-card">
              <h3>Customer-Facing IoT</h3>
              <ul className="svc-list">
                <li>Smart kiosks, connected devices, and mobile apps.</li>
                <li>Usage-based billing and subscription models.</li>
                <li>Telemetry-driven product improvements.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* PROCESS + STACK */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>How we deliver IoT projects</h2>
            <p>
              A structured approach that balances hardware constraints, cloud
              scalability, and security.
            </p>
          </div>

          <div className="svc-stats-row" style={{ marginBottom: "16px" }}>
            <div className="svc-stat-card">
              <div className="svc-stat-label">01 · Discover & Design</div>
              <div className="svc-stat-value">
                Map devices, data points, user journeys, and integration
                touchpoints.
              </div>
            </div>
            <div className="svc-stat-card">
              <div className="svc-stat-label">02 · Build & Integrate</div>
              <div className="svc-stat-value">
                Implement firmware, APIs, cloud services, and dashboards in
                small iterations.
              </div>
            </div>
            <div className="svc-stat-card">
              <div className="svc-stat-label">03 · Monitor & Scale</div>
              <div className="svc-stat-value">
                Add alerts, analytics, and optimization as adoption grows.
              </div>
            </div>
          </div>

          <div className="svc-card">
            <h3>Tech stack & platforms</h3>
            <p className="svc-text-soft">
              We work with cloud-native and open-source components that are easy
              to maintain and extend.
            </p>
            <div className="svc-chip-row" style={{ marginTop: "10px" }}>
              <span className="svc-chip">MQTT / WebSockets</span>
              <span className="svc-chip">REST & GraphQL APIs</span>
              <span className="svc-chip">AWS IoT / Azure IoT</span>
              <span className="svc-chip">Time-series databases</span>
              <span className="svc-chip">React / React Native</span>
              <span className="svc-chip">Node.js / Python</span>
            </div>
          </div>

          <div className="svc-cta-block">
            <h3>Have an IoT idea or an existing device?</h3>
            <p>
              Share your current setup and what you want to measure or automate.
              We’ll respond with a practical architecture and implementation
              plan.
            </p>
            {/* <button className="svc-cta-primary">Schedule a 30-minute IoT consult</button> */}
            <Link to="/contact">
              <button className="svc-cta-primary">
                Schedule a 30-minute IoT consult{" "}
              </button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
